/**
 * 关键指标卡片组件
 */

import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import { ShopOutlined, TeamOutlined, StarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import type { CompetitorData } from '../types';

interface KeyMetricsProps {
    data: CompetitorData;
}

export const KeyMetrics: React.FC<KeyMetricsProps> = ({ data }) => {
    const gs = data.global_stats;

    return (
        <Row gutter={12} style={{ marginBottom: 12 }}>
            <Col span={3}>
                <Card size="small">
                    <Statistic title="关键词" value={data.total_keywords} valueStyle={{ fontSize: 20 }} />
                </Card>
            </Col>
            <Col span={3}>
                <Card size="small">
                    <Statistic
                        title="去重ASIN"
                        value={gs.unique_asins}
                        prefix={<ShopOutlined />}
                        valueStyle={{ fontSize: 20 }}
                    />
                </Card>
            </Col>
            <Col span={3}>
                <Card size="small">
                    <Statistic
                        title="品牌数"
                        value={gs.unique_brands}
                        prefix={<TeamOutlined />}
                        valueStyle={{ fontSize: 20 }}
                    />
                </Card>
            </Col>
            <Col span={4}>
                <Card size="small">
                    <Statistic title="总销量" value={gs.total_sales} valueStyle={{ fontSize: 20 }} />
                </Card>
            </Col>
            <Col span={4}>
                <Card size="small">
                    <Statistic title="总销售额" value={gs.total_revenue} prefix="$" valueStyle={{ fontSize: 20 }} />
                </Card>
            </Col>
            <Col span={3}>
                <Card size="small">
                    <Statistic
                        title="平均Rating"
                        value={gs.avg_rating?.toFixed(2) || '-'}
                        prefix={<StarOutlined />}
                        valueStyle={{ fontSize: 20, color: gs.avg_rating >= 4.3 ? '#52c41a' : '#faad14' }}
                    />
                </Card>
            </Col>
            <Col span={4}>
                <Card size="small">
                    <Statistic
                        title="平均上架"
                        value={Math.round(gs.avg_days || 0)}
                        suffix="天"
                        prefix={<ClockCircleOutlined />}
                        valueStyle={{ fontSize: 20 }}
                    />
                </Card>
            </Col>
        </Row>
    );
};
